import React from 'react';

import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import CreateIcon from '@material-ui/icons/Create';

export const columns = (onClickUpdateIcon, toogleDeleteConfirmModal, handleActive) => [
  {
    dataField: '#',
    text: 'No',
    headerStyle: { width: '3vw' },
    style: { verticalAlign: 'middle' },
    formatter: (cell, row, rowIndex) => {
      return rowIndex + 1;
    },
  },
  {
    dataField: 'conversationStartTime',
    text: 'Conversation Start Time',
    headerStyle: { textAlign: 'center' },
    style: { verticalAlign: 'middle' },
  },
  {
    dataField: 'conversationEndTime',
    text: 'Conversation End Time',
    headerStyle: { textAlign: 'center' },
    style: { verticalAlign: 'middle' },
  },
  {
    dataField: 'replyStartTime',
    text: 'Reply Start Time',
    headerStyle: { textAlign: 'center' },
    style: { verticalAlign: 'middle' },
  },
  {
    dataField: 'conversationDuration',
    text: 'Conversation Duration',
    headerStyle: { textAlign: 'center' },
    style: { verticalAlign: 'middle' },
  },
  {
    dataField: 'replyDuration',
    text: 'Reply Duration',
    headerStyle: { textAlign: 'center' },
    style: { verticalAlign: 'middle' },
  },
  {
    dataField: 'messageCount',
    text: 'Message Count',
    headerStyle: { textAlign: 'center' },
    style: { verticalAlign: 'middle' },
  },

  {
    dataField: '#',
    text: 'Nama Agent',
    headerStyle: { textAlign: 'center' },
    style: { verticalAlign: 'middle' },
    formatter: (cell, row) => {
          return <div>{row.csagent.name}</div>
        },
  },
  {
    dataField: '#',
    text: 'CID Customer',
    headerStyle: { textAlign: 'center' },
    style: { verticalAlign: 'middle' },
    formatter: (cell, row) => {
      return <div>{row.customer?.customer_id}</div>
    },
  },

  {
    dataField: '#',
    text: 'Nama Customer',
    headerStyle: { textAlign: 'center' },
    style: { verticalAlign: 'middle' },
    formatter: (cell, row) => {
      return <div>{row.customer?.name}</div>
    },
  },
  // {
  //   dataField: '#',
  //   text: 'Action',
  //   headerStyle: { width: '150px', textAlign: 'center' },
  //   style: { verticalAlign: 'middle', textAlign: 'center' },
  //   formatter: (cell, row) => {
  //     return (
  //       <div className="container-button">
  //         <div className="rounded" onClick={() => onClickUpdateIcon(row)}>
  //           <CreateIcon />
  //         </div>
  //         {/* <div
  //           className="rounded"
  //           onClick={() => toogleDeleteConfirmModal(row)}>
  //           <DeleteOutlineIcon />
  //         </div> */}
  //         <div
  //           className="rounded"
  //           onClick={() => handleActive(row)}
  //           >
  //           {row.active ? <VisibilityOffIcon/> : <VisibilityIcon />}
  //         </div>
  //       </div>
  //     );
  //   },
  // },
];
